<!--
 * @Description: 基础配置车辆维护
 * @Autor: wangwangwang
 * @Date: 2021-06-08 13:46:30
 * @LastEditors: hexy
 * @LastEditTime: 2024-12-12 15:38:50
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="margin-bottom: 10px; display: inline-block">
                <span style="margin-right: 12px">车牌号</span>
                <el-input v-model="tableParam.plateNumber" style="width: 240px" placeholder="请输入" clearable
                  @keyup.enter.native="gettableData()" />
                <!-- <el-input v-model="tableParam.code" style="width: 240px" placeholder="请输入" clearable @keyup.enter.native="gettableData()" /> -->
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">所属单位</span>
                <el-input v-model="tableParam.company" style="width: 240px" placeholder="请输入" clearable
                  @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">车辆类型</span>
                <el-select v-model="tableParam.carTypeId" style="width: 240px" placeholder="请选择">
                  <el-option v-for="item in carTypelist" :key="item.id" :label="item.itemName"
                    :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">更新时间</span>
                <el-date-picker v-model="startTimDateEndTimDate" unlink-panels type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="(tableParam.createTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.updateTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
                @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" @click="init()">重 置</el-button>
              <el-button size="small" style="margin-left: 10px" class="bottom_all_two"
                @click="tableParamType = true">高级搜索</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small"
                class="bottom_all" style="margin-left: 0" @click="pagesaddFromDate(), (isLook = false)">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
              <!-- <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small"
                class="bottom_three" @click="Update(1)">
                <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
                启用
              </el-button> -->
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small"
                class="bottom_four" @click="Update(0)">
                <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
                删除
              </el-button>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'EWEIM') !== -1" size="small"
                class="bottom_four" @click="handleDown"> 批量下载 </el-button>
            </div>
            <div>
              <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'BAOCUNPXH') !== -1" :underline="false"
                @click="SortNum()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_sort1"></i>
                </span>
                保存排序号
              </el-link>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCHU') !== -1" :underline="false"
                @click="load()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>
                导出
              </el-link>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="e => {
                  this.handleSelectionChange(e), (this.selectRow = e);
                }
                ">
              <el-table-column align="center" type="selection"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                  :min-width="item.width" :fixed="item.label == '操作' || item.label == '二维码' ? 'right' : false">
                  <template slot-scope="scope">
                    <span v-if="scope.row.enable == 0 && item.label == '状态'" style="color: red">禁用</span>
                    <span v-if="scope.row.enable == 1 && item.label == '状态'" style="color: #00a754">启用</span>
                    <el-button
                      v-if="item.label == '操作' && ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"
                      class="bottom_one" size="mini" @click="pagesupdateFromDate(scope.row), (isLook = false)">
                      <i class="icon iconfont iconicon_button_modification" style="font-size: 12px"></i>
                      修改
                    </el-button>
                    <el-button v-if="item.label == '操作'" class="bottom_one" size="mini" @click="changeDetail(scope.row)">
                      修改详情 </el-button>
                    <el-button
                      v-if="item.label == '操作' && ButtonList.findIndex(res => res.buttonValue == 'SHEBEIWEIHU') !== -1"
                      class="bottom_one" size="mini" @click="maintenance(scope.row)">设备维护</el-button>
                    <div
                      v-if="item.label == '二维码' && scope.row.quickMarkUrl && ButtonList.findIndex(res => res.buttonValue == 'EWEIM') !== -1"
                      class="table_link">
                      <a :href="'/file/' + scope.row.quickMarkUrl" download>下载</a>
                    </div>
                    <div v-if="item.label == '二维码'" class="table_link" style="cursor: pointer">
                      <div @click="showPreview(scope.row)">预览</div>
                    </div>
                    <div v-if="item.label == '排序号'">
                      <el-input v-model="scope.row.sortNum"></el-input>
                    </div>
                    <div v-if="item.label == '外部车辆'">
                      <span>{{ ["", "否", "是"][scope.row.sysType] }}</span>
                    </div>
                    <span
                      v-if="item.label !== '操作' && item.label !== '排序号' && item.label !== '状态' && item.label !== '使用状况' && item.label !== '二维码' && item.label !== '外部车辆'">{{
                        scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加修改 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false"
      :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" style="padding: 20px" :rules="rules" :inline="true" :model="fromDate"
          :disabled="isLook" label-width="110px">
          <el-form-item prop="sysType">
            <span slot="label" style="color: #ff0000">公司类型</span>
            <el-select ref="carType" v-model="fromDate.sysType" placeholder="请选择" @change="changeSysType()">
              <el-option :key="1" label="内部公司" :value="1"></el-option>
              <el-option :key="2" label="供应商" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- 内部公司表单 -->
          <div v-if="fromDate.sysType == 1">
            <el-form-item prop="plateNumber">
              <span slot="label" style="color: #ff0000">车牌号</span>
              <el-input v-model="fromDate.plateNumber" placeholder="请输入" clearable></el-input>
            </el-form-item>

            <el-form-item prop="carTypeId">
              <span slot="label" style="color: #ff0000">车辆类型</span>
              <el-select ref="carType" v-model="fromDate.carTypeId" placeholder="请选择" @change="
                $nextTick(() => {
                  fromDate.carType = $refs.carType.selectedLabel;
                })
                ">
                <el-option v-for="item in carTypelist" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="carEmissionId">
              <span slot="label" style="color:  #FF0000 ;">车辆排放标准</span>
              <el-select ref="carEmissionId" v-model="fromDate.carEmissionId" clearable placeholder="请选择"
                @change="$nextTick(() => { fromDate.carEmission = $refs.carEmissionId.selectedLabel })">
                <el-option v-for="item in carEmissionlist" :key="item.id" :label="item.itemName"
                  :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="UserInfo.adminStatus == 1" prop="companyId">
              <span slot="label" style="color: #ff0000">所属单位</span>
              <el-select ref="selection1" v-model="fromDate.companyId" placeholder="请选择" @change="
                setstationIdlist(fromDate.companyId),
                $nextTick(() => {
                  fromDate.company = $refs.selection1.selectedLabel;
                }),
                (fromDate.stationId = '')
                ">
                <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="stationId">
              <span slot="label" style="color: #ff0000">站点名称</span>
              <el-select ref="selection2" v-model="fromDate.stationId" placeholder="请选择" @change="
                get_simple_organizationFun(fromDate.stationId),
                $nextTick(() => {
                  fromDate.stationName = $refs.selection2.selectedLabel;
                })
                ">
                <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cardId">
              <span slot="label">RFID</span>
              <el-input v-model="fromDate.cardId" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="enable">
              <el-radio-group v-model="fromDate.enable">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="maxLoad">
              <span slot="label">最大承重</span>
              <el-input v-model="fromDate.maxLoad" placeholder="请输入"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @change="fromDate.maxLoad = $regExp.checkNum3(fromDate.maxLoad)"
                @input="fromDate.maxLoad = $regExp.checkNum(fromDate.maxLoad)"
                @blur="fromDate.maxLoad = $regExp.blurCheckNum(fromDate.maxLoad)">
                <template v-if="fromDate.carType == '' || fromDate.carType == '罐车'" slot="append">方</template>
                <template v-else-if="fromDate.carType == '槽罐车' || fromDate.carType == '货车' || fromDate.carType == '东风车'"
                  slot="append">吨</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="tare">
              <span slot="label" style="color: #ff0000">皮重</span>
              <el-input v-model="fromDate.tare" placeholder="请输入"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="fromDate.tare = $regExp.checkNum(fromDate.tare)"
                @blur="fromDate.tare = $regExp.blurCheckNum(fromDate.tare)">
                <template slot="append">吨</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="gpsFactoryId">
              <span slot="label" style="color:  #FF0000 ;">GPS厂家</span>
              <el-select ref="gpsFactoryId" v-model="fromDate.gpsFactoryId" clearable placeholder="请选择"
                @change="$nextTick(() => { fromDate.gpsFactoryName = $refs.gpsFactoryId.selectedLabel })">
                <el-option v-for="item in gpsFactoryList" :key="item.id" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div v-else>
            <el-form-item prop="supplierId" :rules="[{ required: true, message: '请选择供应商', trigger: 'change' }]">
              <span slot="label" style="color: #ff0000">供应商</span>
              <el-select v-model="fromDate.supplierId" placeholder="请选择" @change="changeContract">
                <el-option v-for="item in contractIdList" :key="item.supplierId" :label="item.supplierName"
                  :value="item.supplierId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="stationId" :rules="[{ required: true, message: '请选择站点', trigger: 'change' }]">
              <span slot="label" style="color: #ff0000">站点</span>
              <el-select ref="station" v-model="fromDate.stationId" placeholder="请选择" @change="
                $nextTick(() => {
                  fromDate.stationName = $refs.station.selectedLabel;
                })
                ">
                <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="plateNumber">
              <span slot="label" style="color: #ff0000">车牌号</span>
              <el-input v-model="fromDate.plateNumber" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item prop="carTypeId">
              <span slot="label" style="color: #ff0000">车辆类型</span>
              <el-select ref="carType" v-model="fromDate.carTypeId" placeholder="请选择" @change="
                $nextTick(() => {
                  fromDate.carTypeName = $refs.carType.selectedLabel;
                })
                ">
                <el-option v-for="item in carTypelist" :key="item.id" :label="item.itemName"
                  :value="String(item.id)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="carEmissionId">
              <span slot="label" style="color:  #FF0000 ;">车辆排放标准</span>
              <el-select ref="carEmissionId" v-model="fromDate.carEmissionId" clearable placeholder="请选择"
                @change="$nextTick(() => { fromDate.carEmission = $refs.carEmissionId.selectedLabel })">
                <el-option v-for="item in carEmissionlist" :key="item.id" :label="item.itemName"
                  :value="item.itemValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="enable">
              <el-radio-group v-model="fromDate.enable">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="车辆性质" prop="enable">
              <el-radio-group v-model="fromDate.carNature">
                <el-radio :label="1">自用</el-radio>
                <el-radio :label="2">临时</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="maxLoad">
              <span slot="label">最大承重</span>
              <el-input v-model="fromDate.maxLoad" type="Number" placeholder="请输入" clearable>
                <template slot="append">方</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="tare">
              <span slot="label" style="color: #ff0000">皮重</span>
              <el-input v-model="fromDate.tare" type="Number" placeholder="请输入" clearable>
                <template slot="append">吨</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="gpsFactoryId">
              <span slot="label" style="color:  #FF0000 ;">GPS厂家</span>
              <el-select ref="gpsFactoryId" v-model="fromDate.gpsFactoryId" clearable placeholder="请选择"
                @change="$nextTick(() => { fromDate.gpsFactoryName = $refs.gpsFactoryId.selectedLabel })">
                <el-option v-for="item in gpsFactoryList" :key="item.id" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="QueryPlateNumber()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设备维护 -->
    <el-dialog v-dialogDrag :visible.sync="maintenanceDialog" width="1072px" :close-on-click-modal="false"
      :before-close="resetOtherFromDate">
      <span slot="title" class="dialog-title">设备维护</span>
      <div class="dialogOtherinfo">
        <div class="nav-one" style="min-height: 530px">
          <div class="navone-nav">
            <template v-for="(item, index) in navlist">
              <div :key="index" :class="navindex == item.id ? 'active' : ''" @click="navindex = item.id">{{ item.name }}
              </div>
            </template>
          </div>
          <div v-if="navindex == 1" class="navone-info">
            <el-form :inline="true" label-width="110px">
              <el-form-item>
                <span slot="label">故障类型</span>
                <el-select v-model="maintenanceData.typeId" placeholder="请选择">
                  <el-option v-for="item in MaintenanceType" :key="item.id" :label="item.itemName"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <span slot="label">维修时间</span>
                <el-date-picker v-model="maintenanceData.maintainTime" type="datetime"
                  placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <span slot="label">备 注</span>
                <el-input v-model="maintenanceData.remark" placeholder="请输入" class="textarea" type="textarea"
                  resize="none" rows="10" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="navindex == 2" class="navone-info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="maintenancelist" tooltip-effect="dark">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="typeName" label="故障类型" width="180" align="center"></el-table-column>
              <el-table-column prop="maintainTime" label="维修时间" width="180" align="center"></el-table-column>
              <el-table-column prop="remark" label="备注" width="auto" align="center"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间" width="180" align="center"></el-table-column>
            </el-table>
            <el-pagination :current-page.sync="maintenanceParam.page" :page-size="maintenanceParam.pageSize"
              layout="prev, pager, next, jumper" :total="maintenancetotal"
              @current-change="getmaintenancelist()"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">关 闭</el-button>
        <el-button v-if="navindex == 1" class="bottom_all" style="margin-left: 24px" @click="submitmaintenance()">提
          交</el-button>
      </span>
    </el-dialog>
    <!-- 高级搜索 -->
    <el-dialog v-dialogDrag :visible.sync="tableParamType" width="530px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo">
        <el-form ref="dialogForm" :inline="true" :model="tableParam" label-width="90px">
          <el-form-item>
            <span slot="label" style="color: #ff0000">站点名称</span>
            <el-input v-model="tableParam.stationName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="color: #ff0000">车辆编码</span>
            <el-input v-model="tableParam.code" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">状态</span>
            <el-select v-model="tableParam.enable" placeholder="请选择">
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two"
          @click="(tableParamType = false), (tableParam.stationName = ''), (tableParam.plateNumber = ''), (tableParam.enable = '')">取
          消</el-button>
        <el-button class="bottom_all" @click="gettableData(), (tableParamType = false)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改记录 -->
    <el-dialog :visible.sync="changeDetailDig" width="25%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">修改记录</span>
      <div class="dialogBlock">
        <div class="dialogHistory1" style="width: 100%">
          <el-timeline v-if="changeDetailData.length > 0">
            <el-timeline-item v-for="(item, index) in changeDetailData" :key="index" color="#00A754" placement="top">
              <p>{{ item.createUserName }}-{{ item.createTime }}修改明细</p>
              <el-button type="text" size="mini" class="bottom_text"
                @click="pagesupdateFromDate(item), (isLook = true)">查看详情</el-button>
            </el-timeline-item>
          </el-timeline>
          <div v-else>
            <span>暂无记录</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="changeDetailDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" imgsText="预览二维码" :imgList="imgList" :mp4List="[]" :fileList="[]"
      @reset="imgsDialog = false"></ShowDetails>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import ShowDetails from "@/components/showdetails";
import { get_station_list } from "@/api/smart/stocksake.js";
import { queryPage, batchUpdateOrDelete, updateSortNum, saveOrUpdate, Download, carMaintainQueryPage, carMaintainsave, queryCarNoData } from "@/api/basicConfig/car.js";
import { getDicType, permissionsCompanyList, getUserAutList, get_simple_organization, queryListByCompany } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    ShowDetails,
  },
  mixins: [mixin],
  data() {
    const validatePass1 = (rule, value, callback) => {
      console.log(value)
      // const regExp =
      //   /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$)/;
      const regExp =
        /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
      let re = new RegExp(regExp);
      if (re.test(value)) {
        callback();
      } else {
        callback(new Error("请输正确的车牌号!"));
      }
    };
    return {
      tableParamType: false,
      imgsDialog: false,
      startTimDateEndTimDate: [],
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete,
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        {
          label: "车辆自编码",
          width: "120",
          prop: "code",
          status: true,
        },
        {
          label: "车牌号",
          width: "100",
          prop: "plateNumber",
          status: true,
        },
        { label: "状态", width: "100", prop: "", status: true, },
        {
          label: "车辆类型",
          width: "120",
          prop: "carTypeName",
          status: true,
        },
        {
          label: "车辆排放标准",
          width: "120",
          prop: "carEmission",
          status: true,
        },
        {
          label: "所属单位",
          width: "160",
          prop: "company",
          status: true,
        },
        {
          label: "站点名称",
          width: "220",
          prop: "stationName",
          status: true,
        },
        {
          label: "外部车辆",
          width: "220",
          prop: "sysType",
          status: true,
        },
        {
          label: "最大载重",
          width: "100",
          prop: "maxLoad",
          status: true,
        },
        {
          label: "皮重(吨)",
          width: "100",
          prop: "tare",
          status: true,
        },
        {
          label: "二维码",
          width: "140",
          prop: "",
          status: true,
        },
        { label: "排序号", width: "120", prop: "sortNum", status: true },
        {
          label: "更新时间",
          width: "160",
          prop: "updateTime",
          status: true,
        },
        {
          label: "操作",
          width: "220",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        plateNumber: [
          { required: true, message: "请输入车牌号", trigger: "change" },
          { validator: validatePass1, trigger: "change" },
        ],
        carTypeId: [{ required: true, message: "请选择车辆类型", trigger: "change" }],
        sysType: [{ required: true, message: "请选择公司类型", trigger: "change" }],
        stationId: [{ required: true, message: "请选择站点", trigger: "change" }],
        companyId: [{ required: true, message: "请选择所属单位", trigger: "blur" }],
        tare: [{ required: true, message: "请输入皮重", trigger: "blur" }],
      },
      fromDate: {
        id: "",
        roughWeight: "",
        code: "",
        plateNumber: "",
        carTypeId: "",
        cardId: "",
        carType: "",
        carTypeName: "",
        company: "",
        companyId: "",
        stationName: "", //站点名称
        stationId: "", //站点id
        enable: 1,
        carNature: 1,
        maxLoad: "",
        tare: "",
        sysType: 1,
      },
      showtype: false,
      typelist: [],
      carTypelist: [],
      carEmissionlist:[],
      gpsFactoryList:[],
      companylist: [],
      /*设备维护*/
      id: "",
      maintenanceDialog: false,
      navlist: [
        {
          name: "录入维修结果",
          id: 1,
        },
        {
          name: "设备维修记录",
          id: 2,
        },
      ],
      maintenanceParam: {
        page: 1,
        pageSize: 9,
      },
      maintenanceData: {
        typeId: "",
        typeName: "",
        remark: "",
        maintainTime: "",
      },
      navindex: 1,
      maintenancelist: [],
      stationIdlist: [],
      maintenancetotal: 0,
      MaintenanceType: [],
      oldplateNumber: "",
      imgList: [],
      selectRow: [],
      contractIdList: [], //合同列表
      stationList: [], //站点列表
      changeDetailData: [],
      changeDetailDig: false,
      isLook: false,
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companylist = await permissionsCompanyList();
    this.stationIdlist = await getUserAutList(true);
    this.tableParam = { ...this.tableParam, code: "", carTypeId: "", stationName: "", plateNumber: "", enable: "", sysType: "" };
    this.gettableData();
    this.gettypeList();
    getDicType({ code: "MaintenanceType" }).then(res => {
      this.MaintenanceType = res.data.items;
    });
    queryListByCompany().then(res => {
      this.contractIdList = res.data;
    });
    getDicType({ code: "carEmissions" }).then((res) => {
      this.carEmissionlist = res.data.items;
    });
    getDicType({ code: "gpsFactory" }).then((res) => {
      this.gpsFactoryList = res.data.items;
    });
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    //改变公司类型还原表单
    changeSysType() {
      let sysType = this.fromDate.sysType;
      let carNo = this.fromDate.plateNumber;
      let id = this.fromDate.id;
      this.$data.fromDate = this.$options.data().fromDate;
      this.fromDate.sysType = sysType;
      this.fromDate.plateNumber = carNo;
      this.fromDate.id = id;
    },
    //合同改变获取站点
    changeContract(value) {
      const newData = this.contractIdList.find(item => item.supplierId === value);
      this.stationList = newData ?  JSON.parse(newData.stations) : [];
      this.fromDate.stationId = "";
    },
    // handleSelectionChange (selectRow) {
    //   this.selectRow = selectRow;
    // },
    handleDown() {
      if (!this.selectRow.length) {
        this.$message.warning("请选择要下载的数据");
        return;
      }
      for (let i = 0; i < this.selectRow.length; i += 1) {
        let link = document.createElement("a");
        link.href = "/file/" + this.selectRow[i].quickMarkUrl;
        link.download = `${this.selectRow[i].plateNumber}.png`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    },
    showPreview(data) {
      let items = data.quickMarkUrl?.split(",").map(res => "/file/" + res);
      this.imgList = items;
      this.imgsDialog = true;
    },
    /**通过站点查询公司 */
    get_simple_organizationFun(id) {
      get_simple_organization({ id: id }).then(res => {
        this.fromDate.companyId = res.data.id;
        this.fromDate.company = res.data.name;
      }); //查询站点所属公司
    },
    /*根据公司获取站点*/
    setstationIdlist(companyId) {
      get_station_list({ parentId: companyId }).then(res => {
        this.stationIdlist = res.data;
      });
    },
    /*类别维护*/
    gettypeList() {
      /*数据来源字典*/
      getDicType({ code: "vanType" }).then(res => {
        this.carTypelist = res.data.items;
      });
    },
    maintenance(low) {
      this.id = low.id;
      this.maintenanceDialog = true;
      this.maintenanceData = {
        typeId: "",
        typeName: "",
        remark: "",
        maintainTime: "",
      };
      this.getmaintenancelist();
    },
    getmaintenancelist() {
      carMaintainQueryPage({ ...this.maintenanceParam, carId: this.id }).then(res => {
        this.maintenancetotal = res.data.totalRows;
        this.maintenancelist = res.data.data;
      });
    },
    changeDetail(data) {
      queryCarNoData({ plateNumber: data.plateNumber }).then(res => {
        this.changeDetailDig = true;
        this.changeDetailData = res.data;
      });
    },
    pagesupdateFromDate(data) {
      this.oldplateNumber = data.plateNumber;
      if (data.sysType == 1) {
        this.setstationIdlist(data.companyId);
      } else {
        const newData = this.contractIdList.find(item => item.supplierId === data.supplierId);
        this.stationList = newData ?  JSON.parse(newData.stations) : [];
      }
      this.updateFromDate(data, "修改");
    },
    pagesaddFromDate() {
      this.addFromDate("添加");
      this.oldplateNumber = "";
      let size = this.stationIdlist.findIndex(res => res.id == this.UserInfo.pointIds[0]);
      if (size != -1) {
        this.fromDate.stationId = this.stationIdlist[size].id;
        this.fromDate.stationName = this.stationIdlist[size].name;
      }
    },
    QueryPlateNumber() {
      // let _this = this;
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          if (this.fromDate.carTypeId) {
            this.fromDate.carTypeValue = this.$fromatTable(this.carTypelist, this.fromDate.carTypeId, "id", "itemName");
          }
          if (this.fromDate.sysType == 2) {
            let item = this.contractIdList.find(v => v.supplierId == this.fromDate.supplierId);
            if (!item) {
              this.$message.warning("无供应商信息");
              return;
            }
            this.fromDate.companyId = item.exteriorCompanyId;
            this.fromDate.company = item.externalCompany;
            this.fromDate.supplierId = item.supplierId;
            this.fromDate.supplierName = item.supplierName;
          }
          this.pagessubmitFromDate();
          // if (this.oldplateNumber) {
          //   if (this.oldplateNumber !== _this.fromDate.plateNumber) {
          //     QueryPlateNumber({
          //       plateNumber: _this.fromDate.plateNumber,
          //     }).then(res => {
          //       if (res.data) {
          //         this.pagessubmitFromDate();
          //         return;
          //       }
          //       this.$message.error("车牌重复，请重新输入");
          //     });
          //   } else {
          //     this.pagessubmitFromDate();
          //   }
          // } else {
          //   QueryPlateNumber({
          //     plateNumber: _this.fromDate.plateNumber,
          //   }).then(res => {
          //     if (res.data) {
          //       this.pagessubmitFromDate();
          //       return;
          //     }
          //     this.$message.error("车牌重复，请重新输入");
          //   });
          // }
        }
      });
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.fromDate.carTypeName = _this.carTypelist.find(function (obj) {
            return obj.id == _this.fromDate.carTypeId;
          })?.itemName;
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitmaintenance() {
      this.maintenanceData.maintainTime = new Date(this.maintenanceData.maintainTime).Format("yyyy-MM-dd hh:mm:ss");
      this.maintenanceData.typeName = this.MaintenanceType.find(res => res.id == this.maintenanceData.typeId).itemName;
      carMaintainsave({ ...this.maintenanceData, carId: this.id }).then(res => {
        if (res.code === 1001) {
          this.$message.success("录入成功");
          this.resetOtherFromDate();
        }
      });
    },
    resetOtherFromDate() {
      this.maintenanceDialog = false;
    },
    init() {
      /*重置数据*/
      this.startTimDateEndTimDate = [];
      this.tableParam.carTypeId = "";
      this.tableParam.code = "";
      this.tableParam.company = "";
      this.tableParam.stationName = "";
      this.tableParam.plateNumber = "";
      this.tableParam.enable = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogOtherinfo {
  .el-pagination {
    padding: 10px 0;
  }

  min-height: 530px;

  .textarea {
    width: 870px;
  }

  .el-input,
  .el-select {
    width: 375px;
  }
}

.dialogBlock {
  display: flex;

  .dialogHistory1 {
    overflow-y: auto;
    height: calc(45vh - 140px);
  }
}

.table_link {
  margin: 0 0 0 10px;
  border: $bg_color 1px solid;
  color: $bg_color;
  border-radius: 3px;
  font-size: 14px;
  height: 30px;
  background: #ffffff;

  a {
    display: inline-block;
    line-height: 29.31px;
    color: $bg_color;
    text-decoration: none;
    font-size: 14px;
  }
}

.table_link:hover {
  color: #ffffff;
  background: $bg_color;

  a {
    color: #ffffff;
  }
}

.dialoginfo {

  .el-input,
  .el-select {
    width: 280px;
  }
}
</style>
